"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const VidBackwardIcon = props => /*#__PURE__*/_react.default.createElement(_base.Icon, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m13.02 13.857 6.273 3.858c.937.577 1.697.155 1.697-.955V7.212c0-1.103-.757-1.533-1.697-.955l-6.273 3.858V7.212c0-1.103-.757-1.533-1.697-.955l-7.62 4.686c-.936.576-.94 1.51 0 2.087l7.62 4.685c.937.577 1.697.155 1.697-.955z"/></svg>`
}, props));
VidBackwardIcon.displayName = 'VidBackwardIcon';
var _default = exports.default = VidBackwardIcon;